<div class="flex min-h-[calc(100vh_-_72px)] flex-col">
  <div class="sidebar-header flex items-center justify-between gap-2 px-1 py-2">
    <img src="/assets/testlogo.png" alt="PIMS" class="h-[42px] w-[42px]" />
    <button
      class="bg-primary hover-bg-primary-hover h-[28px] w-[28px] cursor-pointer rounded-full"
      (click)="hideSidebar()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 24 24"
        class="ltr:block rtl:hidden">
        <path
          class="stroke-bg-white"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m14 7l-5 5l5 5"
          stroke-width="1" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28px"
        height="28px"
        viewBox="0 0 24 24"
        class="ltr:hidden rtl:block">
        <path
          class="stroke-bg-white"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m10 7l5 5l-5 5"
          stroke-width="1" />
      </svg>
    </button>
  </div>
  <ul class="border-border-card mt-1 flex w-full flex-col gap-2 border-b-[2px] pb-3">
    <li>
      <a routerLink="/user" class="sidebar-item" [class.active]="isDashboardActive()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 256 256">
          <path
            fill="currentColor"
            d="M216 115.54V208a8 8 0 0 1-8 8H160a8 8 0 0 1-8-8v-48a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v48a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8v-92.46a8 8 0 0 1 2.62-5.92l80-75.54a8 8 0 0 1 10.77 0l80 75.54a8 8 0 0 1 2.61 5.92" />
        </svg>
        <span i18n="@@userSidebarDashboard">Dashboard</span>
      </a>
    </li>

    <li *hasScope="SCOPES.PHARMACIES.READ_ALL">
      <a
        routerLink="/user/pharmacies"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <g fill="currentColor">
            <path
              d="M9 5c0-.406.152-.747.356-.884c.15-.1.713-.336 2.19.416a1 1 0 0 0 .908-1.782c-1.723-.877-3.16-1-4.21-.296C7.248 3.121 7 4.274 7 5H5c-.552 0-1.008.45-.919.996a6.3 6.3 0 0 0 .528 1.683c.402.85.991 1.62 1.734 2.27a8.2 8.2 0 0 0 2.596 1.518c.66.24 1.354.4 2.061.478V15h2v-3.055a9 9 0 0 0 1.934-.433a2 2 0 0 1-.934 1.22v2.142c1.725-.444 3-2.01 3-3.874a1 1 0 0 0-.111-.459q.405-.274.768-.591a7 7 0 0 0 1.734-2.271a6.4 6.4 0 0 0 .528-1.683C20.009 5.45 19.552 5 19 5z" />
            <path
              d="M9.5 13h.5v2h-.5a.5.5 0 0 0 0 1h4.338a2.162 2.162 0 0 1 1.14 4H17v2H7v-2h4a1 1 0 0 1 .183-.577a1 1 0 0 1 .523-.379l2.183-.728a.162.162 0 0 0-.051-.316H9.5a2.5 2.5 0 0 1 0-5" />
          </g>
        </svg>
        <span i18n="@@userSidebarPharmacies">Pharmacies</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/products"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M16.2 3.5c-1-1-2.3-1.5-3.5-1.5s-2.6.5-3.5 1.5L3.4 9.1c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l5.7-5.7c1.9-1.9 1.9-5.1 0-7m-1.4 5.6L12 11.9L8.4 8.4L4 12.8c0-.8.2-1.7.9-2.3l5.7-5.7c.5-.5 1.3-.8 2-.8s1.5.3 2.1.8c1.2 1.3 1.2 3.1.1 4.3m4.8-2c0 .8-.2 1.5-.4 2.3c1 1.2 1 3-.1 4.1l-2.8 2.8l-1.5-1.5l-2.8 2.8c-1.3 1.3-3.1 2-4.8 2c.2.3.4.6.7.9c2 2 5.1 2 7.1 0l5.7-5.7c2-2 2-5.1 0-7.1c-.5-.2-.8-.4-1.1-.6" />
        </svg>
        <span i18n="@@userSidebarProducts">Products</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/offers"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M16.2 3.5c-1-1-2.3-1.5-3.5-1.5s-2.6.5-3.5 1.5L3.4 9.1c-2 2-2 5.1 0 7.1s5.1 2 7.1 0l5.7-5.7c1.9-1.9 1.9-5.1 0-7m-1.4 5.6L12 11.9L8.4 8.4L4 12.8c0-.8.2-1.7.9-2.3l5.7-5.7c.5-.5 1.3-.8 2-.8s1.5.3 2.1.8c1.2 1.3 1.2 3.1.1 4.3m4.8-2c0 .8-.2 1.5-.4 2.3c1 1.2 1 3-.1 4.1l-2.8 2.8l-1.5-1.5l-2.8 2.8c-1.3 1.3-3.1 2-4.8 2c.2.3.4.6.7.9c2 2 5.1 2 7.1 0l5.7-5.7c2-2 2-5.1 0-7.1c-.5-.2-.8-.4-1.1-.6" />
        </svg>
        <span i18n="@@userSidebarOffers">Offers</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/categories"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M2 2h9v9H2zm15.5 0C20 2 22 4 22 6.5S20 11 17.5 11S13 9 13 6.5S15 2 17.5 2m-11 12l4.5 8H2zM19 17h3v2h-3v3h-2v-3h-3v-2h3v-3h2z" />
        </svg>
        <span i18n="@@userSidebarCategories">Categories</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/cart"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <app-cart-icon />
        <span i18n="@@userSidebarCart">Cart</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/companies"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M21.5 8.5c0-1.404 0-2.107-.337-2.611a2 2 0 0 0-.552-.552c-.441-.295-1.034-.332-2.115-.336q.005.438.004.91V7.25h1a.75.75 0 0 1 0 1.5h-1v1.5h1a.75.75 0 0 1 0 1.5h-1v1.5h1a.75.75 0 0 1 0 1.5h-1v6.5H17V6c0-1.886 0-2.828-.586-3.414S14.886 2 13 2h-2c-1.886 0-2.828 0-3.414.586S7 4.114 7 6v15.25H5.5v-6.5h-1a.75.75 0 0 1 0-1.5h1v-1.5h-1a.75.75 0 0 1 0-1.5h1v-1.5h-1a.75.75 0 0 1 0-1.5h1V5.91q-.001-.47.004-.91c-1.081.005-1.674.042-2.115.337a2 2 0 0 0-.552.552C2.5 6.393 2.5 7.096 2.5 8.5v12.75H2a.75.75 0 0 0 0 1.5h20a.75.75 0 0 0 0-1.5h-.5zM12 4.25a.75.75 0 0 1 .75.75v1.25H14a.75.75 0 0 1 0 1.5h-1.25V9a.75.75 0 0 1-1.5 0V7.75H10a.75.75 0 0 1 0-1.5h1.25V5a.75.75 0 0 1 .75-.75M9.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75M12 18.25a.75.75 0 0 1 .75.75v2.25h-1.5V19a.75.75 0 0 1 .75-.75"
            clip-rule="evenodd" />
        </svg>
        <span i18n="@@userSidebarCompanies">Companies</span>
      </a>
    </li>
    <li>
      <button class="sidebar-item" [class.active]="isOrdersActive()" (click)="toggleOrders()">
        <app-document-order-icon />

        <span i18n="@@userSidebarOrders">Orders</span>

        <app-chevron-bottom-icon
          class="ms-auto transition-transform duration-300"
          [class.rotate-180]="isOrdersOpen()" />
      </button>

      <ul class="submenu flex flex-col" [class.open]="isOrdersOpen()">
        <li class="tabs-text text-[14px]">
          <a
            routerLink="/user/orders"
            class="submenu-item sidebar-submenu flex items-center gap-2"
            routerLinkActive="active">
            <span i18n="@@userSidebarOrders">Orders</span>
          </a>
        </li>

        <li class="tabs-text text-[14px]">
          <a
            routerLink="/user/returns"
            class="submenu-item sidebar-submenu flex items-center gap-2"
            routerLinkActive="active">
            <span i18n="@@userSidebarReturns">Returns</span>
          </a>
        </li>
      </ul>
    </li>
    <li>
      <button
        class="sidebar-item"
        [class.active]="isInvoicesActive()"
        routerLinkActive="active"
        (click)="goToInvoices($event)">
        <app-document-with-bookmark-icon />
        <span i18n="@@userSidebarInvoicesAndPayments">Invoices & Payments</span>
        <app-chevron-bottom-icon
          class="ms-auto transition-transform duration-300"
          [class.rotate-180]="isInvoicesOpen()" />
      </button>

      <ul class="submenu flex flex-col" [class.open]="isInvoicesOpen()">
        <li class="tabs-text text-[14px]">
          <a
            routerLink="/user/invoices"
            class="submenu-item sidebar-submenu flex items-center gap-2"
            routerLinkActive="active">
            <app-file-text-icon />
            <span i18n="@@userSidebarInvoices">Invoices</span>
          </a>
        </li>
        <li *hasScope="SCOPES.PAYMENT_REQUESTS.READ_ALL" class="tabs-text text-[14px]">
          <a
            routerLink="/user/payment-requests"
            class="submenu-item sidebar-submenu flex items-center gap-2"
            routerLinkActive="active">
            <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
            </svg>
            <span i18n="@@userSidebarPaymentRequests">Payment Requests</span>
          </a>
        </li>
      </ul>
    </li>

    <li>
      <a
        routerLink="/user/wishlist"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="m12 21.35l-1.45-1.32C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5c0 3.77-3.4 6.86-8.55 11.53z" />
        </svg>
        <span i18n="@@userSidebarWishlist">Wishlist</span>
      </a>
    </li>
    <li>
      <a
        routerLink="/user/notifications"
        class="sidebar-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M21 19v1H3v-1l2-2v-6c0-3.1 2.03-5.83 5-6.71V4a2 2 0 0 1 2-2a2 2 0 0 1 2 2v.29c2.97.88 5 3.61 5 6.71v6zm-7 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2" />
        </svg>
        <span i18n="@@userSidebarNotifications">Notifications</span>
      </a>
    </li>
  </ul>
  <div class="mt-auto flex flex-col gap-2 pt-3">
    <button
      class="bg-primary hover-bg-primary-hover mb-3 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-md px-3 py-1.5 text-[14px] font-medium text-white"
      (click)="logout()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h6q.425 0 .713.288T12 4t-.288.713T11 5H5v14h6q.425 0 .713.288T12 20t-.288.713T11 21zm12.175-8H10q-.425 0-.712-.288T9 12t.288-.712T10 11h7.175L15.3 9.125q-.275-.275-.275-.675t.275-.7t.7-.313t.725.288L20.3 11.3q.3.3.3.7t-.3.7l-3.575 3.575q-.3.3-.712.288t-.713-.313q-.275-.3-.262-.712t.287-.688z" />
      </svg>
      <span i18n="@@userSidebarLogout">Logout</span>
    </button>
  </div>
</div>
